import radioactiveSymbol from "../../assets/radioactive-symbol.png";

export function CodeInput({ value, onChange, expectedLength }: { value: string; onChange: (value: string) => void, expectedLength: number }) {
  const hashtags = "#".repeat(Math.max(0, expectedLength - value.length));

  return (
    <div className="flex items-center gap-3">
      <img
        src={radioactiveSymbol}
        alt="Symbole radioactif"
        className="radiation-animate radioactive-yellow w-5 h-5 shrink-0 opacity-70"
      />
      <label className="uppercase tracking-[0.2em] text-xs text-[#9a9a85] shrink-0">
        Entrez votre code
      </label>
      <div className="relative flex-1 min-w-0 border border-[#3a3f2a] focus-within:border-[#39ff14] bg-black/50 px-3 py-2 transition-colors">
        <div aria-hidden className="text-2xl tracking-[0.5em] whitespace-nowrap overflow-hidden pointer-events-none">
          <span className="text-[#39ff14]">{value}</span>
          <span className="text-[#3a3f2a]">{hashtags}</span>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value.slice(0, expectedLength))}
          autoComplete="off"
          aria-label="Entrez votre code"
          className="absolute inset-0 w-full h-full bg-transparent text-transparent caret-[#39ff14] outline-none text-2xl tracking-[0.5em] px-3 py-2"
        />
      </div>
    </div>
  );
}
